module.exports = __webpack_public_path__ + "img/family.d7b1a473.svg";